<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <el-button @click="addPg" :loading="btnLoading">新增</el-button> -->
      <!-- <el-button @click="chgPg" :loading="btnLoading">修改</el-button>
      <el-button @click="delPg" :loading="btnLoading">删除</el-button> -->
      <!-- <el-button @click="close">关闭</el-button> -->
    <!-- </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">评分方式</div>
          <div class="field">
            <el-select v-model="pfxm.pfxmdoneflg" placeholder="请选择" @change = "search">
              <el-option
                v-for="(item, index) in pfxmdoneflgList"
                :key="index"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            @cellClick="cellClick"  @cellDblClick="cellDblClick"
          :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pfxmIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btnLoading: false,
        btn:{},
        cols: [
          { field: 'pfxmseq',fieldtype: 'I', title: '顺序',calculExpr:'', width: 80 },
          { field: 'pfxmname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'pfxmflgCN', fieldtype: 'C', title: '类型',calculExpr:'',addNewRowFlg: false},
          { field: 'pfxmratio', fieldtype: 'F', title: '百分比',calculExpr:'',addNewRowFlg: false},
          { field: 'pfxmremark', fieldtype: 'C', title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        pfxm: {},
        pfxmdoneflgList:[],  //成交方式
        pfxmflgPrice:false,
        query:{
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addPg())
      this.$on('CHG', () => this.chgPg())
      this.$on('DEL', () => this.delPg())
    },
    activated() {
      this.init()
      if(this.pfxm.pfxmdoneflg){
        this.getPageList()
      }
    },
    mounted () {
      this.getPfxmdoneflgList()
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async init() {
        this.list = []
        this.btnLoading = false
        this.pfxmflgPrice = false
      },
      // async close() {
      //   this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      // },
      async addPg () {
        // console.log('this.list',this.pfxm.pfxmdoneflg);
        if(!this.pfxm.pfxmdoneflg){
          this.$message.error('请先筛选评分方式！')
          return
        }
        if(this.pfxm.pfxmdoneflg === '1' && this.list.length){
          this.$message.error('价格成交法已存在选项！')
          return
        }
        let form = {
          pfxmid: 0,
          pfxmdoneflg:this.pfxm.pfxmdoneflg,
          pgratiototal: this.total,
          pfxmflgPrice:this.pfxmflgPrice
        }
        this.$router.push({name: 'pfxmForm', params: {form: form, type: 1}})
      },
      vggridClick(code,row){
        this.pfxm = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async chgPg () {
        if(this.pfxm.pfxmflg === '2'){
          this.pfxm.pfxmflgPrice = this.pfxmflgPrice
        }
        this.pfxm.pgratiototal = this.total - Number(this.pfxm.pfxmratio)
        this.$router.push({name: 'pfxmForm', params: {form: this.pfxm, type: 2}})
      },
      async delPg () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/pfxm/delPg',
            method: "post",
            data: this.pfxm
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellDblClick () {
        this.pfxm.pgratiototal = this.total - Number(this.pfxm.pfxmratio)
        this.$router.push({name: 'pfxmForm', params: {form: this.pfxm,innerbtn: this.btn.inner, type: 3}})
      },
      async cellClick (row) {
        this.pfxm = row.row
        this.pfxm.pfxmdoneflg = String(this.pfxm.pfxmdoneflg)
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/pfxm/getPgList',
          params: this.pfxm
        })
        this.pfxmflgPrice = false
        res.forEach(key => {
          if(key.pfxmflg === '1'){
            key.pfxmflgCN = "价格项"
            this.pfxmflgPrice = true
          }
          else{
            key.pfxmflgCN = "商务技术项"
          }
        })
        this.list = res
        this.loading = false
      },
      async getPfxmdoneflgList () {
        this.pfxmdoneflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectdoneflg'}
        })
      },
      search () {
        this.getPageList()
      }
    },
    filters: {
    },
    computed: {
      total () {
        return this.list.length ? this.list.map(t => Number(t.pfxmratio)).reduce((a, b) => a + b) : 0
      }
    }
  }
</script>
<style lang="scss">

</style>
